import { Button, Typography } from "@mui/material";
import { FC } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { RootState } from "../../app/store";
import { setErrors } from "../../app/store/app/appSlice";
import CustomDialog from "./custom-dialog";

const ErrorDialog: FC = () => {
  const dispatch = useAppDispatch();

  const errors = useAppSelector((state: RootState) => state.app.errors);
  const errorAction = useAppSelector(
    (state: RootState) => state.app.errorAction
  );

  const onClose = () => {
    if (!!errorAction) {
      errorAction();
    }
    dispatch(setErrors(undefined));
  };

  return (
    <CustomDialog
      isOpen={!!errors}
      closeIcon
      title="Error"
      onClose={onClose}
      showWarningIcon
      actions={
        <Button
          variant="outlined"
          onClick={onClose}
          color="secondary"
          disableRipple
        >
          OK
        </Button>
      }
      content={errors?.map((warning) => (
        <Typography key={warning}>{warning}</Typography>
      ))}
    />
  );
};

export default ErrorDialog;
